import { main } from './main.js'
import { studios } from './studios.js'
import { dashboard } from './dashboard.js'
import { account } from './account.js'
import { marketplace } from './marketplace.js'
import { sessionBridge } from './session-bridge.js'
import { notFound } from './notFound.js'
import { signin } from '../../shared/pages/auth/signin.js'
import { signup } from '../../shared/pages/auth/signup.js'
import { signupConfirmation } from '../../shared/pages/auth/signup-confirmation.js'
import { resetPassword } from '../../shared/pages/auth/reset-password.js'
import { waitlist } from '../../shared/pages/waitlist.js'

const rootRedirect = {
  onRender: (el) => {
    const sdk = el.context?.methods?.sdk
    const token = sdk?.getAuthToken?.()
    el.router(token ? '/dashboard' : '/signin', el.getRoot())
  }
}

// Bare `/studios` has no slug — bounce to /dashboard so the user picks
// (or auto-selects) an active workspace, which is then deep-linked.
const studiosRedirect = {
  onRender: (el) => el.router('/dashboard', el.getRoot())
}

export default {
  '/': rootRedirect,
  '/dashboard': dashboard,
  '/account': account,
  '/marketplace': marketplace,
  '/_session-bridge': sessionBridge,
  '/studio': studiosRedirect,
  '/studio/*': studios,
  '/signin': signin,
  '/signup': signup,
  '/signup-confirmation': signupConfirmation,
  '/reset-password': resetPassword,
  '/waitlist': waitlist,
  '/404': notFound,
  '/*': main
}
